import { useMutation, useQuery } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { queryClient } from '../store/provider/TanStackProvider'
import { HistoryResMock, SurgeryDataMock } from '../types/history.type'
import { FamilyProps } from './useFamily'

export const useSurgery = (arg?: FamilyProps) => {
  const patientId = arg?.patientId
  const intakeId = arg?.intakeId
  const sortDir = arg?.sortDir || 'desc'

  const { data: surgeries, isLoading } = useQuery({
    queryFn: async () => {
      let endpoint = `/surgical_histories?`
      if (intakeId) endpoint += `intake_id=${intakeId}&`
      if (patientId) endpoint += `patient_id=${patientId}&`
      if (sortDir) endpoint += `sort_dir=${sortDir}&`
      const { data } = await AXIOS_INSTANCE.get<HistoryResMock<SurgeryDataMock[]>>(endpoint)
      return data.data
    },
    queryKey: ['surgeries', { intakeId, patientId }]
  })

  const { mutateAsync: createSurgery } = useMutation({
    mutationFn: async (formVal: any) => {
      const { data } = await AXIOS_INSTANCE.post(`/surgical_histories`, formVal, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['surgeries'] })
      queryClient.invalidateQueries({ queryKey: ['surgeries', { patientId }] })
    }
  })

  return { createSurgery, isLoading, surgeries }
}
